import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/entities-to-logs')({
  beforeLoad: () => getTitleContextSlice('Entities To Logs'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
